// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2zHFW","inner":"Footer_inner__3PRM8","nextIcon":"Footer_nextIcon__1QdEQ","innerLeft":"Footer_innerLeft__2rokn"};